/*
  Capital RC - search suggestions as you type
  Uses Shopify's built-in Predictive Search (no app needed).
  Works on every search box that submits to /search (desktop header, mobile header, menu drawer).
*/
(function () {
  'use strict';

  var MIN_CHARS = 2;
  var MAX_PRODUCTS = 6;
  var MAX_COLLECTIONS = 3;
  var DELAY = 200; // ms to wait after typing stops

  var money = function (value) {
    var n = Number(value);
    if (isNaN(n)) return '';
    return '$' + n.toLocaleString('en-NZ', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };

  var squash = function (s) {
    return String(s || '').toLowerCase().replace(/[^a-z0-9]/g, '');
  };

  var sizedImage = function (url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  };

  // In-stock first; within that, products whose brand matches the search come first.
  var rankProducts = function (products, query) {
    var q = squash(query);
    return products
      .map(function (p, i) {
        var v = squash(p.vendor);
        var brandMatch = q.length > 1 && v && (v.indexOf(q) === 0 || q.indexOf(v) === 0);
        return { p: p, i: i, score: (p.available ? 0 : 2) + (brandMatch ? 0 : 1) };
      })
      .sort(function (a, b) { return a.score - b.score || a.i - b.i; })
      .map(function (x) { return x.p; });
  };

  function attach(form) {
    var input = form.querySelector('input[name="q"]');
    if (!input || form.getAttribute('data-predictive') === 'on') return;
    form.setAttribute('data-predictive', 'on');
    form.classList.add('predictive-search-form');
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('aria-autocomplete', 'list');

    var searchPath = form.getAttribute('action') || '/search';

    var box = document.createElement('div');
    box.className = 'predictive-search';
    box.setAttribute('role', 'listbox');
    box.hidden = true;
    form.appendChild(box);

    var timer = null;
    var controller = null;
    var lastQuery = '';
    var active = -1;

    var links = function () { return box.querySelectorAll('a.predictive-search__link'); };

    var close = function () {
      box.hidden = true;
      active = -1;
      input.setAttribute('aria-expanded', 'false');
    };

    var open = function () {
      box.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    };

    var highlight = function (index) {
      var items = links();
      if (!items.length) return;
      if (index < 0) index = items.length - 1;
      if (index >= items.length) index = 0;
      Array.prototype.forEach.call(items, function (a) { a.classList.remove('is-active'); });
      items[index].classList.add('is-active');
      items[index].scrollIntoView({ block: 'nearest' });
      active = index;
    };

    var render = function (query, products, collections) {
      var html = '';

      if (collections.length) {
        html += '<p class="predictive-search__heading">Categories</p><ul class="predictive-search__list">';
        collections.slice(0, MAX_COLLECTIONS).forEach(function (c) {
          html += '<li><a class="predictive-search__link predictive-search__link--collection" href="' + esc(c.url) + '">' + esc(c.title) + '</a></li>';
        });
        html += '</ul>';
      }

      if (products.length) {
        html += '<p class="predictive-search__heading">Products</p><ul class="predictive-search__list">';
        products.slice(0, MAX_PRODUCTS).forEach(function (p) {
          var img = p.image || (p.featured_image && p.featured_image.url) || '';
          html +=
            '<li><a class="predictive-search__link predictive-search__item' + (p.available ? '' : ' is-sold-out') + '" href="' + esc(p.url) + '">' +
              (img ? '<img src="' + esc(sizedImage(img, 120)) + '" alt="" width="56" height="56" loading="lazy">' : '<span class="predictive-search__noimg"></span>') +
              '<span class="predictive-search__text">' +
                '<span class="predictive-search__title">' + esc(p.title) + '</span>' +
                '<span class="predictive-search__price">' + money(p.price) +
                  (p.available ? '' : ' <span class="predictive-search__badge">Sold out</span>') +
                '</span>' +
              '</span>' +
            '</a></li>';
        });
        html += '</ul>';
      }

      if (!products.length && !collections.length) {
        html += '<p class="predictive-search__empty">No matches for &ldquo;' + esc(query) + '&rdquo;</p>';
      }

      html +=
        '<a class="predictive-search__link predictive-search__all" href="' + searchPath + '?q=' + encodeURIComponent(query) + '">' +
          'See all results for &ldquo;' + esc(query) + '&rdquo; &rarr;' +
        '</a>';

      box.innerHTML = html;
      active = -1;
      open();
    };

    var search = function (query) {
      if (controller) controller.abort();
      controller = 'AbortController' in window ? new AbortController() : null;

      var url = searchPath + '/suggest.json?q=' + encodeURIComponent(query) +
        '&resources[type]=product,collection' +
        '&resources[limit]=10' +
        '&resources[limit_scope]=each' +
        '&resources[options][unavailable_products]=last' +
        '&resources[options][fields]=title,product_type,variants.sku,vendor,tag';

      fetch(url, controller ? { signal: controller.signal } : {})
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
        .then(function (data) {
          if (query !== lastQuery) return;
          var results = (data && data.resources && data.resources.results) || {};
          render(query, rankProducts(results.products || [], query), results.collections || []);
        })
        .catch(function () { /* network hiccup or aborted: leave normal search working */ });
    };

    input.addEventListener('input', function () {
      var query = input.value.trim();
      lastQuery = query;
      clearTimeout(timer);
      if (query.length < MIN_CHARS) { close(); return; }
      timer = setTimeout(function () { search(query); }, DELAY);
    });

    input.addEventListener('focus', function () {
      if (box.innerHTML && input.value.trim().length >= MIN_CHARS) open();
    });

    input.addEventListener('keydown', function (e) {
      if (box.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); highlight(active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); highlight(active - 1); }
      else if (e.key === 'Escape') { close(); }
      else if (e.key === 'Enter' && active > -1) {
        e.preventDefault();
        window.location.href = links()[active].href;
      }
    });

    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) close();
    });
  }

  function init() {
    var forms = document.querySelectorAll('form[action$="/search"]');
    Array.prototype.forEach.call(forms, attach);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
